import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import AutoResizeTextarea from '../form/inputs/AutoResizeTextarea'
import Button from '../form/inputs/Button'

type LlmPromptInputProps = {
    value: string
    onChange: (nextValue: string) => void
    onSubmit: () => void
    textareaId?: string
    placeholder?: string
    minRows?: number
    maxRows?: number
    formClassName?: string
    textareaClassName?: string
    submitButtonContent?: React.ReactNode
    submitButtonStyle?: React.ComponentProps<typeof Button>['style']
    submitButtonSize?: React.ComponentProps<typeof Button>['size']
    disableSubmit?: boolean
    onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void
}

export default function LlmPromptInput({
    value,
    onChange,
    onSubmit,
    textareaId,
    placeholder = "Who's your perfect hire...",
    minRows = 4,
    maxRows = 10,
    formClassName,
    textareaClassName,
    submitButtonContent,
    submitButtonStyle = 'primary',
    submitButtonSize = 'normal',
    disableSubmit = false,
    onKeyDown,
}: LlmPromptInputProps): React.JSX.Element {
    const formClasses = [
        'rounded-3xl border border-gray-200 bg-white p-4 shadow-sm sm:p-6',
        formClassName,
    ]
        .filter(Boolean)
        .join(' ')

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        onSubmit()
    }

    return (
        <form onSubmit={handleSubmit} className={formClasses}>
            <AutoResizeTextarea
                id={textareaId}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                minRows={minRows}
                maxRows={maxRows}
                className={
                    textareaClassName ??
                    'w-full bg-transparent text-base text-gray-800 outline-none placeholder:text-gray-400'
                }
            />

            <div className="mt-4 flex justify-end">
                <Button
                    type="submit"
                    style={submitButtonStyle}
                    size={submitButtonSize}
                    enabled={!disableSubmit}
                >
                    {submitButtonContent ?? (
                        <FontAwesomeIcon icon={faArrowUp} />
                    )}
                </Button>
            </div>
        </form>
    )
}
